import {Component} from '@angular/core';
import {LocaleManager} from '../../managers/locale.manager';
import {LocaleEnum} from "../../enums/locale.enum";
import {RouteManager} from '../../managers/route.manager';
import {PreferenceManager} from '../../managers/preference.manager';
import {FooterContentResources} from '../../content/resources/footer.content-resources';
import {RouteEnum} from '../../enums/route.enum';
import {ContentManager} from '../../content/managers/content.manager';
import {FetchPriorityEnum} from '../../enums/fetch-priority.enum';
import {LoadingEnum} from '../../enums/loading.enum';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: false,
})
export class FooterComponent {

    collapsed = true;

    showLanguageSwitcherBar = this.preferenceManager.getDoNotShowLanguageSwitcherBar() && this.localeManager.isCurrentBrowserPreferredLanguageDifferentThenCurrentLocale();
    protected readonly LocaleEnum = LocaleEnum;
    protected readonly FooterContentResources = FooterContentResources;
    protected readonly RouteEnum = RouteEnum;
    protected readonly FetchPriorityEnum = FetchPriorityEnum;
    protected readonly LoadingEnum = LoadingEnum;

    constructor(
        private readonly preferenceManager: PreferenceManager,
        public readonly localeManager: LocaleManager,
        public readonly routeManager: RouteManager,
        private readonly contentManager: ContentManager,
    ) {
    }

    doNotShowLanguageSwitcherBar() {
        this.preferenceManager.setDoNotShowLanguageSwitcherBar();
    }

    toggleCollapsed() {
        this.collapsed = !this.collapsed;
    }
}
